import React from 'react'
import './../ButtonStyle.css'
const PrimaryButtonImg = ({onClick,isdisabled,children,img,classname}) => {
  return (
    <button className={classname} onClick={onClick} disabled={isdisabled}><img src={img} alt=""  />{children}</button>
  )
}

export default PrimaryButtonImg